import { scrileConnect as ProvidersFactory } from "@scrile/api-provider/dist/";
import Configuration from "@scrile/api-provider/dist/Configuration";
import emitter from "@/lib/emitter";
import config from "@/config";
import AppStorage from "./appStorage";

const providers = ProvidersFactory({
  url: config.apiUrl,
  notificationCB: (event, payload) => {
    emitter.emit(event, payload);
  },
  appStorage: AppStorage,
  websocketOnly: true,
});

Configuration.featureLiveChat = config.featureGoLive;
Configuration.featurePaidMessageAttachments = true;

export default providers.providers;
